export default "__VITE_ASSET__366ce86c__"